import { Perks } from "components/deals/Perks";
import React from "react";

export const CrmPerks = () => {
  return <Perks />;
};
